/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Knp_Guide_Delete_FailedInputs */

const en_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Failed to delete guide: ${i?.error}`)
};

const fr_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Échec de la suppression du guide : ${i?.error}`)
};

const de_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Leitfaden konnte nicht gelöscht werden: ${i?.error}`)
};

const it_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Impossibile eliminare la guida: ${i?.error}`)
};

const ru_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Не удалось удалить руководство: ${i?.error}`)
};

const es_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`No se pudo eliminar la guía: ${i?.error}`)
};

const zh_cn2_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`删除指南失败：${i?.error}`)
};

const ja_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ガイドの削除に失敗しました: ${i?.error}`)
};

const hi_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`गाइड को हटाने में विफल: ${i?.error}`)
};

const pt_pt2_knp_guide_delete_failed = /** @type {(inputs: Knp_Guide_Delete_FailedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Falha ao excluir o guia: ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Failed to delete guide: {error}" |
*
* @param {Knp_Guide_Delete_FailedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_guide_delete_failed = /** @type {((inputs: Knp_Guide_Delete_FailedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Guide_Delete_FailedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_guide_delete_failed(inputs)
	if (locale === "de") return de_knp_guide_delete_failed(inputs)
	if (locale === "it") return it_knp_guide_delete_failed(inputs)
	if (locale === "ru") return ru_knp_guide_delete_failed(inputs)
	if (locale === "es") return es_knp_guide_delete_failed(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_guide_delete_failed(inputs)
	if (locale === "ja") return ja_knp_guide_delete_failed(inputs)
	if (locale === "hi") return hi_knp_guide_delete_failed(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_guide_delete_failed(inputs)
	return en_knp_guide_delete_failed(inputs)
});